import {store} from "../../Store/index.js";

export interface ElevenLabsTTSOptions {
	text: string;
	voiceId: string;
	apiKey: string;
}

/**
 * Generate speech using ElevenLabs API
 * @returns Audio data as ArrayBuffer
 */
export async function GenerateSpeechWithElevenLabs(options: ElevenLabsTTSOptions): Promise<ArrayBuffer> {
	const {text, voiceId, apiKey} = options;

	// ElevenLabs API endpoint for text-to-speech
	const url = `https://api.elevenlabs.io/v1/text-to-speech/${voiceId}`;

	const response = await fetch(url, {
		method: "POST",
		headers: {
			"Accept": "audio/mpeg",
			"Content-Type": "application/json",
			"xi-api-key": apiKey,
		},
		body: JSON.stringify({
			text,
			model_id: "eleven_multilingual_v2", // Using the current default model (supports multiple languages)
			voice_settings: {
				stability: 0.5,
				similarity_boost: 0.75,
			},
		}),
	});

	if (!response.ok) {
		const errorText = await response.text();
		throw new Error(`ElevenLabs API error: ${response.status} ${response.statusText} - ${errorText}`);
	}

	return await response.arrayBuffer();
}

export interface ElevenLabsVoice {
	voice_id: string;
	name: string;
	preview_url?: string;
}

/**
 * Get list of available voices from ElevenLabs
 */
export async function GetElevenLabsVoices(apiKey: string): Promise<ElevenLabsVoice[]> {
	const url = "https://api.elevenlabs.io/v1/voices";

	const response = await fetch(url, {
		method: "GET",
		headers: {
			"Accept": "application/json",
			"xi-api-key": apiKey,
		},
	});

	if (!response.ok) {
		const errorText = await response.text();
		throw new Error(`ElevenLabs API error: ${response.status} ${response.statusText} - ${errorText}`);
	}

	const data = await response.json();
	return data.voices;
}

/**
 * Get the ElevenLabs API key from settings
 */
export function GetElevenLabsAPIKey(): string | null {
	return store.main.settings.elevenLabsAPIKey ?? null;
}